exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-edit-training-project-dialog .ant-modal-body {\n  max-height: calc(100vh - 180px);\n  overflow: auto;\n}\n.create-edit-training-project-dialog .ant-form-item {\n  margin-bottom: 16px;\n}\n.create-edit-training-project-dialog .ant-form-item-explain {\n  margin-top: 8px;\n  font-size: 11px;\n  min-height: unset;\n}\n", ""]);

// exports
